import {AfterViewInit, Component, Inject, ViewChild} from '@angular/core';
import { VentanaFlotante } from '../models/VentanaFlotante';
import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from "@angular/material/table";
import {GestionesVariasService} from "../services/bd/GestionesVarias/gestiones-varias.service";

@Component({
  selector: 'ral-busqueda-matricula',
  templateUrl: './busqueda-matricula.component.html',
  styleUrls: ['./busqueda-matricula.component.scss']
})
export class BusquedaMatriculaComponent extends VentanaFlotante implements AfterViewInit
{

  listadoResultados : any[] = [];
  displayedColumns =
    [
      "del",//del.
      "hoja",//hoja
      "fecha",//fecha
      "nombre",
      "titular",
      "matricula",
      "marca",
      "modelo",
      "siniestro",
      "usuari",//usuario
      "gestionada",//??
      "idrls",
      "agente",
      "fecrls",
      "estado_rls"//agente (rls)
    ];
  dataSource : MatTableDataSource<any> = new MatTableDataSource(this.listadoResultados);
  formInic : any;
  @ViewChild(MatPaginator) paginator: MatPaginator | null = null;
  constructor
  (
    public override dialogRef: MatDialogRef<Component>,
    @Inject(MAT_DIALOG_DATA) public override data: any | null,
    private serviceRls: GestionesVariasService,
    private dialog : MatDialog // Additional parameter to override in the constructor
  )
  {
    super(dialogRef, data); // Call the parent class constructor
  }

  ngAfterViewInit() {
    this.dataSource.paginator = this.paginator;
  }
  ngOnInit() {
    this.listadoResultados = this.data.listado || [];
    this.dataSource.data = this.listadoResultados;
    this.formInic = this.data.form;
  }

  volcarSeleccion(seleccion:any, column:any)
  {
    if (column == "idrls"){
      if(Number(seleccion.idrls) && (seleccion.estado_rls == "PENDIENTE" || seleccion.estado_rls == "RELLAMADA")){
        var idGestion = seleccion.idrls;
        if (this.formInic.idIncid != ''){
          idGestion = this.formInic.idIncid;
        }
        this.serviceRls.gestionIdRlsHoja(this.formInic.token, this.formInic.usuario, seleccion.del, seleccion.hoja, seleccion.idrls, seleccion.agente, idGestion).then(res => {
          this.formInic.mostrarArgumentario("Atención", ["Servicio Actualizado correctamente e Incidencia Gestionada."]);
          this.dialogRef.close();
        }).catch(err => {
          this.formInic.mostrarArgumentario("Atención",["Imposible grabar linea en Incidencia del Servicio."],false, true, true);
        })
      }else{
        this.formInic.mostrarArgumentario("Atención",["ID de RLS ya Gestionado o No existe para asignar a Hoja."],false, true, true);
      }
    }else{
      this.dialogRef.close(seleccion);
    }

  }

  onPageChange(event: any)
  {
    if(this.paginator)
      this.paginator.pageIndex = event.pageIndex;
  }
}
